import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styles from "./allAssessments.module.css";

/* ---------- helpers ---------- */
const fetchDepartmentData = async () => {
  try {
    const response = await axios.post(
      "https://casaahaanahotels.com/get_master_assessment_type",
      {}
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching department data:", error);
    return [];
  }
};

const fetchAssessments = async (filters) => {
  try {
    const response = await axios.post(
      "https://casaahaanahotels.com/new_list_assessments",
      filters,
      { headers: { "Content-Type": "application/json" } }
    );
    return Array.isArray(response.data?.result) ? response.data.result : [];
  } catch (error) {
    console.error("Error fetching assessments:", error);
    throw error;
  }
};

/* ---------- component ---------- */
const CompanyAssessmentTable = () => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* company info pulled from localStorage (user_data) */
  const [companyName, setCompanyName] = useState("");
  const [companyCode, setCompanyCode] = useState("");

  /* department filter */
  const [departments, setDepartments] = useState([]);
  const [selectedDepartmentCode, setSelectedDepartmentCode] = useState("");

  const navigate = useNavigate();

  /* -------- initial load: get company info & first API call -------- */
  useEffect(() => {
    const loadInitial = async () => {
      // read user_data from localStorage
      const userDataStr = localStorage.getItem("user_data");
      let admincodeFromLS = "";
      if (userDataStr) {
        try {
          const userData = JSON.parse(userDataStr);
          if (userData.companyname) {
            setCompanyName(userData.companyname);
          }
          if (userData.admincode) {
            setCompanyCode(userData.admincode);
            admincodeFromLS = userData.admincode;
          }
        } catch (err) {
          console.error("Error parsing user_data:", err);
        }
      }

      try {
        const initialFilters = {
          useremail: "",
          companycode: admincodeFromLS,
          departmentcode: "",
        };
        const result = await fetchAssessments(initialFilters);
        setAssessments(result);
        setError(result.length === 0 ? "No assessments found." : "");
      } catch {
        setError("Failed to fetch assessments.");
      } finally {
        setLoading(false);
      }
    };

    loadInitial();
  }, []);

  /* -------- load department dropdown once -------- */
  useEffect(() => {
    const loadDepartments = async () => {
      const data = await fetchDepartmentData();
      setDepartments(data);
    };
    loadDepartments();
  }, []);

  /* -------- search handler -------- */
  const handleSearch = async () => {
    setLoading(true);
    setError("");
    try {
      const filters = {
        useremail: "",
        companycode: companyCode,
        departmentcode: selectedDepartmentCode,
      };
      const result = await fetchAssessments(filters);
      setAssessments(result);
      setError(result.length === 0 ? "No assessments found." : "");
    } catch {
      setError("Failed to fetch assessments.");
    } finally {
      setLoading(false);
    }
  };

  /* ---------- render ---------- */
  return (
    <div className={styles.container}>
      {/* Title + Company */}
      <h2 className={styles.title}>
        {companyName || "Assessment List"}
      </h2>

      {/* Department + Search */}
      <div className={styles.filterContainer}>
        <select
          className={styles.departmentDropdown}
          value={selectedDepartmentCode}
          onChange={(e) => setSelectedDepartmentCode(e.target.value)}
        >
          <option value="">All Departments</option>
          {departments.map((dept) => (
            <option
              key={dept.assessment_type_id}
              value={dept.assessment_type_id}
            >
              {dept.AssessmentType}
            </option>
          ))}
        </select>

        <button onClick={handleSearch} className={styles.searchButton}>
          Search
        </button>
      </div>

      {/* status / table */}
      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : error ? (
        <p className={styles.errorText}>{error}</p>
      ) : (
        <div className={styles.tableWrapper}>
          <table className={styles.assessmentTable}>
            <thead>
              <tr>
                <th>Driver Name</th>
                <th>Email</th>
                <th>Company Name</th>
                <th>Star Score</th>
                <th>Completed Date</th>
                <th>Validity</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {assessments.map((assessment, idx) => {
                if (assessment?.driverid && assessment?.score != null) {
                  const firstName =
                    assessment.driver_details?.FirstName || "N/A";
                  const lastName =
                    assessment.driver_details?.LastName || "N/A";
                  const driverName = `${firstName} ${lastName}`;
                  const driverEmail =
                    assessment.driver_details?.DriverEmail || "N/A";
                  const companyName =
                    assessment.company_details?.companyname || "N/A";
                  const starScore = assessment.score;
                  const completedDate = new Date(
                    assessment.timestamp
                  ).toLocaleDateString("en-US");
                  const validityDate = new Date(
                    assessment.validity
                  ).toLocaleDateString("en-US");
                  const assessmentId = assessment.assessementid;

                  return (
                    <tr key={idx}>
                      <td>{driverName}</td>
                      <td>{driverEmail}</td>
                      <td>{companyName}</td>
                      <td>
                        <img
                          src={`https://starbehaviors.com/uploadimage/${starScore}.png`}
                          alt={`Score: ${starScore}`}
                          className={styles.scoreImage}
                        />
                      </td>
                      <td>{completedDate}</td>
                      <td>{validityDate}</td>
                      <td>
                        <button
                          className={styles.viewButton}
                          onClick={() => navigate(`/${assessmentId}`)}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CompanyAssessmentTable;
